import React from "react";

const Dr_Pawan_Kalyan = () => {
  return (
    <>
      <div id="Topmargin1">
        <div className="about_banner">
          <img src="DOCTORS.png" className="about_image" alt=""></img>
        </div>
      </div>
      <div className="container docter_content">
        <h2>Dr. PawanKalyan</h2>
        <div className="row">
          <div className="col-md-6 col-sm-12 Doctor_image_Content">
            <img id="doctor_image" src="02.jpg" alt="Doctor Image"></img>
            <h3>Dr. PawanKalyan</h3>
            <p>
              <b>Consultant Pulmonary, Allergy & Sleep Specialist</b>
            </p>
            <p>
              <b>M.D(Ped)FACI</b>
            </p>
          </div>

          <div className="col-md-6 col-sm-12 Doctor_Text">
            <p>
              Dr.Pawan Kalyan Pinnamaneni MD(PED), pulmonary, allergy and sleep
              specialist at Pinnamaneni hospital, Vuyyuru.He is also the
              consultant doctor in Andhra Hospital, Rainbow hospital, Ankur
              hospital and Harini hospital Vijayawada. In addition to working in
              hospitals, he is a professor at the PSIMS & Research foundation in
              Chinnaavutapalli. His academic record and accomplishments define
              his career. Additionally, he served as on the national advisory
              board for Indian Pediatrics 2020. His track record of success is
              unmatched, as is his commitment to the medical industry. He holds
              fellowships from Saveetha University in Chennai in allergy and
              clinical immunology as well as pediatric pulmonary and sleep
              medicine from Australia. Patients feel utmost comfortable because
              of his compassion and the way he treats children in a playful
              manner by creating a friendly atmosphere. He is renowned for his
              commitment, caring, and, most importantly, for correctly
              diagnosing and treating the illness. We may declare with pride
              that he is one of the sturdy pillars with all the years of
              experience.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dr_Pawan_Kalyan;
